export interface Navbar {
  show: boolean;
  dense: boolean;
  logo: boolean;
}

export interface Fullscreen {
  show: boolean;
  btn: boolean;
}

export interface SettingsPanel {
  show: boolean;
  btn: boolean;
}

export interface Theme {
  index: number;
  dark: boolean;
}

export interface Graph {
  xHour: any;
}

export interface Settings {
  rowPerPage: number[];
  locale: string;
  dense: boolean;
  footer: boolean;
  navbar: Navbar;
  fullscreen: Fullscreen;
  settingsPanel: SettingsPanel;
  theme: Theme;
  country: string[];
  permissions: { [k: string]: string[] };
  graph: Graph;
}

export interface Configs {
  settings: Settings;
}

const configs: Configs = {
  settings: {
    rowPerPage: [10, 20, 30, 40, 50],
    locale: 'en',
    dense: true,
    footer: false,
    navbar: {
      show: true,
      dense: false,
      logo: false,
    },
    fullscreen: {
      show: false,
      btn: true,
    },
    settingsPanel: {
      show: false,
      btn: true,
    },
    theme: {
      index: 0,
      dark: false,
    },
    country: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria"
      , "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina"
      , "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Côte d'Ivoire"
      , "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)"
      , "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia (Czech Republic)", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica"
      , "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", `Eswatini (fmr. "Swaziland")`, "Ethiopia"
      , "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana"
      , "Haiti", "Holy See", "Honduras", "Hungary", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica"
      , "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein"
      , "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico"
      , "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar (formerly Burma)", "Namibia", "Nauru", "Nepal"
      , "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine State"
      , "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis"
      , "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles"
      , "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea"
      , "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo"
      , "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom"
      , "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"],
    permissions: {
      "DASHBOARD_AND_REPORTS": ["read"],
      "OPERATION_INSTRUCTION": ["create", "read", "update", "delete"],
      "ABOUT_PAGE": ["read", "update"],
      "USER_MANAGEMENT": ["create", "read", "update"],
      "GROUP_MANAGEMENT": ["read", "update"],
      "CUSTOMER_MANAGEMENT": ["create", "read", "update"],
      "LOCATION_MANAGEMENT": ["create", "read", "update"],
      "CONTROLLER_MANAGEMENT": ["create", "read", "update", "delete"],
      "UNIT_MANAGEMENT": ["create", "read", "update", "delete"],
      "VARIABLES_MANAGEMENT": ["create", "read", "update", "delete"],
      "RPA_MANAGEMENT": ["create", "read", "update", "delete"],
      "TREATMENT_DATABASE_MANAGEMENT": ["create", "read", "update", "delete"],
      "TREATMENT_MANAGEMENT": ["create", "read", "update", "delete"],
      "TREATMENT_MONITORING_FOR_UNIT": ["read"],
      "RECEIVE_NOTIFICATION": ["read"],
      "FCM_PUSH_NOTIFICATION_MANAGEMENT": ["read"],
      "MAINTENANCE_TRACKING_MANAGEMENT": ["create", "read", "update", "delete"],
      "MAILING_LIST_MANAGEMENT": ["create", "read", "update", "delete"],
      "SHIPMENT_CERTIFICATE_REPORTS": ["create", "read", "update", "delete"],
      "FAILURE_TRACKING_MANAGEMENT": ["create", "read", "update", "delete"],
      "LICENSE": ["read", "update"],
      "LICENSE_LIST": ["create", "read", "update", "delete"],
      "ACTIVITY_LOGS": ["read"],
      "WEB_CONFIG": ["read", "update"],
    },
    graph: {
      xHour: 6,
    },
  },
};


export default configs;
